// Sliding pane with PacmanLoader while redux pending != 0.
// Import this instead of react-sliding-pane — the global AppLayout spinner sits behind the pane overlay.
import React from "react";
import { connect } from "react-redux";
import { PacmanLoader } from "react-spinners";
import SlidingPane from "react-sliding-pane/dist/react-sliding-pane.js";
import "react-sliding-pane/dist/react-sliding-pane.css";

function mapStateToProps(state) {
  return { pending: state.pending };
}

const SlidingPaneHOC = ({ pending, children, ...paneProps }) => (
  <SlidingPane {...paneProps}>
    <div style={{ position: "relative", minHeight: pending != 0 ? "12rem" : undefined }}>
      {pending != 0 && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            background: "rgba(255,255,255,0.75)",
          }}
        >
          <PacmanLoader />
        </div>
      )}
      {children}
    </div>
  </SlidingPane>
);

export default connect(mapStateToProps, {})(SlidingPaneHOC);
